var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87282 6.14316C1.99267 5.06451 2.47207 4.04579 3.25109 3.26676C4.20989 2.36789 5.40839 1.88848 6.66682 1.88848C7.86532 1.88848 9.12375 2.36789 10.0825 3.26676L9.06382 4.28549H12.0601V1.28923L10.9215 2.42781C8.58442 0.0907341 4.74922 0.0907341 2.41214 2.42781C1.45334 3.38661 0.854091 4.64504 0.674316 6.02331V6.68249H1.87282C1.87282 6.50271 1.87282 6.32294 1.87282 6.14316Z",
    fill: "#00FF85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4607 6.6825C11.4607 7.94092 10.9813 9.19935 10.0824 10.0982C9.12362 10.9971 7.92512 11.4765 6.66669 11.4765C5.40826 11.4765 4.20976 10.9971 3.25096 10.0982L4.26969 9.0795H1.27344V12.0757L2.41201 10.9372C3.55059 12.0757 5.04871 12.675 6.66669 12.675C8.28467 12.675 9.78279 12.0757 10.9214 10.9372C12.0599 9.7986 12.6592 8.24055 12.6592 6.6825H11.4607Z",
    fill: "#00FF85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.0fccb451492e360c8dc8a8426587b676.svg";
export { ForwardRef as ReactComponent };